import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const items = ['Complete Box Set (6 modules)', '5 Strategic Bonuses', '365-Day Coaching Curriculum', 'Lifetime access', 'Instant digital access'];
const checkoutUrl = 'https://rugby-ready.impultienda.ar/checkout';
export function PricingSection() {
  return <section id="pricing" className="bg-[#FAFAFA] px-5 py-20 pt-[05px] pb-[05px]" data-id="element-132">
      <div className="mx-auto max-w-xl text-center" data-id="element-133">
        <p className="inline-block bg-[#0A0A0A] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-134">
          Limited-time offer
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#0A0A0A] sm:text-5xl" data-id="element-135">
          Everything included,{' '}
          <span className="text-[#b18b18]" data-id="element-136">one single price.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-[#5A5A66]" data-id="element-137">
          No upsells. No surprises.
        </p>
        <article className="mt-10 overflow-hidden border border-[#E5E5EA] bg-white text-center shadow-xl" data-id="element-138">
          <header className="border-t-4 border-[#d4af37] bg-[#0A0A0A] px-6 py-7" data-id="element-139">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-140">
              Rugby Ready — Complete Box Set
            </h3>
            <p className="mt-2 text-sm font-semibold text-[#d4af37]" data-id="element-141">
              1 Main Box Set (6 modules) + 5 Strategic Bonuses
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-142">
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-[#E5E5EA] py-7" data-id="element-143">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest" data-id="element-144">
                What's included
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-145">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold" data-id="element-146">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-[#d4af37]/20" data-id="element-147">
                      <CheckIcon className="h-3.5 w-3.5 text-[#9b7914]" data-id="element-148" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="mt-7" data-id="element-149">
              <p className="text-sm font-semibold text-[#5A5A66]" data-id="element-150">
                Regular price: <s data-id="element-151">$97 USD</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center" data-id="element-152">
                <span className="font-display text-5xl font-bold" data-id="element-153">$</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-154">
                  27
                </strong>
                <span className="ml-2 text-sm font-bold text-[#5A5A66]" data-id="element-155">
                  USD
                </span>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-156">
                <span className="bg-[#d4af37] px-3 py-1.5 text-xs font-bold uppercase tracking-widest" data-id="element-157">
                  Save $70
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-158">
                  One-time payment
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-159">
                  Lifetime access
                </span>
              </div>
            </div>
            <a href={checkoutUrl} className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-160">
              GET RUGBY READY NOW
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-[#5A5A66]" data-id="element-161">
              <ShieldCheckIcon className="h-4 w-4 text-[#b18b18]" data-id="element-162" />
              Backed by our 7-day money-back guarantee
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-[#E5E5EA] pt-6 text-xs font-bold text-[#5A5A66]" data-id="element-163">
              <span className="flex gap-1" data-id="element-164">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-165" />
                Secure payment
              </span>
              <span className="flex gap-1" data-id="element-166">
                <ZapIcon className="h-4 w-4" data-id="element-167" />
                Instant access
              </span>
              <span className="flex gap-1" data-id="element-168">
                <CreditCardIcon className="h-4 w-4" data-id="element-169" />
                Card · GooglePay · ApplePay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-[#5A5A66]" data-id="element-170">
          You’ll be charged in your local currency.
        </p>
      </div>
    </section>;
}